<app-toasts></app-toasts>
<app-display-selfreg-card *ngIf="serviceSelection && textFields && imageFields" 
	[userRef]="serviceSelection.idNumber" 
	[pin]="serviceSelection.otp" 
	[axonId]="serviceSelection.axonId"
	[textFields]="textFields"
	[qrData]="qrData"
	[image]="imageFields[0]?.image"></app-display-selfreg-card>
